<template>
    <div v-if="client">
        <!-- bk theme -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">BK theme</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.bk.bkTheme"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- bk event numbers -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show short event numbers</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="bkNums"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- bk autoexpress -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show autoexpress</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="bkAutoexpress"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- bk lottery -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show lottery</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="bkLottery"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- bk embeded menu -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show embeded menu</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="bkEmbededMenu"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- bk fake jackpot -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Show embeded fake jackpot</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="bkEmbededFakeJackpot"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

export default {
    name: 'client-settings-view-bk',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        bkNums: {
            get() {
                return this.client.settings.viewSettings.bk.bkNums == 1;
            },
            set(val) {
                this.client.settings.viewSettings.bk.bkNums = val ? 1 : 0;
            }
        },
        bkAutoexpress: {
            get() {
                return this.client.settings.viewSettings.bk.bkAutoexpress == 1;
            },
            set (val) {
                this.client.settings.viewSettings.bk.bkAutoexpress = val ? 1 : 0;
            } 
        },
        bkLottery: {
            get() {
                return this.client.settings.viewSettings.bk.bkLottery == 1;
            },
            set(val) {
                this.client.settings.viewSettings.bk.bkLottery = val ? 1 : 0;
            }
        },
        bkEmbededMenu: {
            get() {
                return this.client.settings.viewSettings.bk.bkEmbededMenu == 1;
            },
            set(val) {
                this.client.settings.viewSettings.bk.bkEmbededMenu = val ? 1 : 0;
            }
        },
        bkEmbededFakeJackpot: {
            get() {
                return this.client.settings.viewSettings.bk.bkEmbededFakeJackpot == 1;
            },
            set(val) {
                this.client.settings.viewSettings.bk.bkEmbededFakeJackpot = val ? 1 : 0;
            }
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/bk.vue